import { render, staticRenderFns } from "./ResultStudentImageList.vue?vue&type=template&id=3731ee21&"
import script from "./ResultStudentImageList.vue?vue&type=script&lang=ts&"
export * from "./ResultStudentImageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports